import { create } from './main';

const exportedInterface = {
  init: create
};

export default exportedInterface;
